module.exports = __webpack_public_path__ + "static/media/down-arrow-gray.d35eb868.svg";